module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main"
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "topnav"
  }, [(true || _vm.user && _vm.user.userId) ? _c('AiTopNav', {
    attrs: {
      "route": _vm.$route,
      "account": _vm.account,
      "searchShow": true,
      "user": _vm.user,
      "company": _vm.company,
      "wo": _vm.wo
    }
  }) : _c('div', [_c('div', {
    attrs: {
      "id": "TopNav"
    }
  }, [_c('a', {
    staticClass: "logo float_left",
    attrs: {
      "href": "/"
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-duilogo"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "icon beta-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-beta"
    }
  })])])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d56c8e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 521
// module chunks = 4